import React from 'react';

import { Trans } from '@i18n';

import useTranslation from '@framework/hooks/useTranslation';

import { Button, Error } from 'styled-system';

type Props = {
    eventId: string;
    resetError: () => void;
};
const ErrorFallback = ({ eventId, resetError }: Props) => {
    const { t } = useTranslation();

    return (
        <Error
            eventId={eventId}
            header={t('Something unexpected occurred')}
            message={
                <Trans parent={null}>
                    We’re sorry about that.
                    <br />
                    Please reload the page to see the content
                </Trans>
            }
        >
            <Button onClick={resetError}>{t('Reload')}</Button>
        </Error>
    );
};

export default ErrorFallback;
